import { defaultProps } from "enhancers"
import HistoryDetailPage from "pages/main/e-claim-history/detail"

export default defaultProps({ withoutCancel: true })(HistoryDetailPage)
